export const PRODUCT_ANALYTICS_EVENT = {
  appSessionStarted: 'app_session_started',
  dataSurfaceViewed: 'data_surface_viewed',
  dataFilterApplied: 'data_filter_applied',
  recordDetailViewed: 'record_detail_viewed',
  notificationReceived: 'notification_received',
  notificationCenterViewed: 'notification_center_viewed',
  notificationOpened: 'notification_opened',
  notificationActionUsed: 'notification_action_used',
  notificationsMarkedRead: 'notifications_marked_read',
} as const;

export type ProductAnalyticsEvent =
  (typeof PRODUCT_ANALYTICS_EVENT)[keyof typeof PRODUCT_ANALYTICS_EVENT];

export type ProductAnalyticsProperty =
  | string
  | number
  | boolean
  | null
  | readonly (string | number | boolean | null)[];

export type ProductAnalyticsProperties = Record<
  string,
  ProductAnalyticsProperty
>;

